import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23 0H1C.4 0 0 .391 0 .978v4.888c0 .586.4.977 1 .977h1v11.731c0 .587.4.978 1 .978h18c.6 0 1-.391 1-.978V6.844h1c.6 0 1-.392 1-.978V.978C24 .391 23.6 0 23 0m-3 17.597H4V6.843h16zm2-12.709H2V1.956h20zm-12 5.866h4c.6 0 1-.391 1-.978 0-.586-.4-.977-1-.977h-4c-.6 0-1 .39-1 .977s.4.978 1 .978"
    }, null, -1)
  ]))]))
}
export default { render: render }